import { fetchApiData } from "../../utils/utils";

export const fetchLiveChannels = async (appInfo) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    // const api = appInfo?.projectDetails?.projectConfig?.pubid == 50141 ? "schedule/fastchannelsv2" : "schedule/fastchannels";
     const api =  "schedule/fastchannelsv2";
    const params = {
        timezone:timeZone
    }
    return await fetchApiData(appInfo,api,params)
}
export const fetchFastChannels = async (appInfo,channelId) => {
    const api = `fastchannel/${channelId}`;  
    return await fetchApiData(appInfo, api);
  };